import { setCropModeElementUuidAction } from 'editor/src/store/editor/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import setFocusedMediaElementUuidOperation from './setFocusedMediaElementUuidOperation';

const stopCropModeOperation = () => (dispatch: ThunkDispatch) => {
  dispatch(setCropModeElementUuidAction(undefined));
  dispatch(setFocusedMediaElementUuidOperation(undefined));
};

export default stopCropModeOperation;
